// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/stateSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
});
